import React from 'react';
import { handleClick, isOtpCallback } from 'Services';
import { ConfirmationCallback, FRCallback } from '@forgerock/javascript-sdk';
import { Button } from 'Components';
import { useJourneyContext } from 'Contexts';
import { Origin } from 'Constants';

interface Props {
  id: string;
  stage: Stage;
  origin: Origin;
  variant: ButtonVariant;
  mobile: boolean;
  callback?: FRCallback;
  children?: React.ReactNode;
  preventDefault?: boolean;
}

export const SubmitButton: React.FC<Props> = ({
  id,
  stage,
  origin,
  variant,
  mobile,
  preventDefault = false,
  callback = undefined,
  children,
}) => {
  const { setStandardSubmit } = useJourneyContext();
  const findOptionIndex = (options: string[], values: string[]) => {
    const value = options.find((option) => values.includes(option));

    return value ? options.indexOf(value) : 0;
  };

  const { setReadOnly, loaderElementId, setLoaderElementId, loading } = useJourneyContext();
  const isLoading = loading;
  const showLoader = isLoading && loaderElementId === id;

  const handleSubmitClick = (event: React.MouseEvent<HTMLElement>) => {
    handleClick(preventDefault, stage, 'submit', origin, mobile)(event);
    setLoaderElementId(id);
    setStandardSubmit(true);

    if (isOtpCallback(callback)) {
      const otpCallback = callback as ConfirmationCallback;
      const option = findOptionIndex(otpCallback.getOptions(), ['otp', 'Send new OTP']);
      otpCallback.setInputValue(option);
      setReadOnly(true);
    }
  };

  return (
    <Button
      variant={variant}
      onClick={handleSubmitClick}
      withLoader={showLoader}
      disabled={isLoading}
      aria-busy={isLoading}
      aria-disabled={isLoading}
      type="submit"
    >
      {children}
    </Button>
  );
};
